export class deleteThreadsModel {
  title: string;
  isDelete: boolean = false;
  hasValidInput: boolean = false;
  list: string[];
  confirmHeader: string;
  confirmSubHeader: string;
  deleteHeader: string;
  deleteSubHeader: string;
  validName: 'Delete';
}

export const deleteAllThreadsDialogInfo: deleteThreadsModel = {
  title: 'Delete All Threads',
  isDelete: false,
  hasValidInput: false,
  list: [
    `Other firm users will not be able to access the deleted threads`,
    `Loss of unsaved data and tasks managed by Luka`,
  ],
  confirmHeader: 'Note: This is an irreversible action',
  confirmSubHeader: "If you still wish to proceed, please enter 'Delete' below",
  deleteSubHeader: 'Are you sure you want to delete all threads?',
  deleteHeader: 'All the conversation threads with Luka will be deleted permanently',
  validName: 'Delete'
};